import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";


const DateRangePickerInline = ({ value = [null, null], onChange }) => {
  const [startDate, endDate] = value;

  const handleStartChange = (newDate) => {
    if (!endDate || newDate <= endDate) {
      onChange([newDate, endDate]);
    } else {
      onChange([newDate, newDate]);
    }
  };

  const handleEndChange = (newDate) => {
    if (!startDate || newDate >= startDate) {
      onChange([startDate, newDate]);
    } else {
      onChange([newDate, newDate]);
    }
  };
//   const startStr = start ? format(start, "dd/MM/yyyy") : "";
//   const endStr = end ? format(end, "dd/MM/yyyy") : "";

  const textFieldStyles = {
    width: "160px",
    input: { cursor: "pointer" },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box display="flex" gap={1} alignItems="center">
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={handleStartChange}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              sx={textFieldStyles}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          )}
          maxDate={endDate || undefined}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={handleEndChange}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              sx={textFieldStyles}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          )}
          minDate={startDate || undefined}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangePickerInline;
